import { useEffect, useRef, useState } from "react";
import ArrowDownIconDark from "~/assets/icons/ArrowDownIconDark";
import OrangeLineSmall from "~/assets/icons/OrangeLineSmall";
import ProductsBreadcrumb from "./ProductsBreadcrumb.client";

type Props = {
    title: string,
    productsPage: number,
    productsTotal: number | undefined,
    descriptionCategory: string,
    loading: boolean
}

export default function ProductsHeader({ title, productsPage, productsTotal, descriptionCategory, loading }: Props) {

    const ref = useRef<HTMLDivElement>();

    const [expandDescription, setExpandDescription] = useState<boolean>(false);
    const [showSeeMore, setShowSeeMore] = useState<boolean>(false);
    const description: string = descriptionCategory.replaceAll("<p>", "").replaceAll("</p>", "<br>");

    const validateDescription = () => {
        countCharacters()
        if (description) {
            if (countCharacters() > getMaxcharacters()) {
                setShowSeeMore(true);
            }
        }
    }

    const getMaxcharacters: () => number = () => {
        const width = screen.width;
        if (width < 640)
            return 80;
        else if (width < 1024)
            return 130;
        else if (width < 1250)
            return 190;
        else
            return 280;
    }

    const countCharacters: () => number = () => {
        const arrayspace = description.split("<br>");
        const arraystrong = description.split("strong");
        const strongs: number = arraystrong.length - 1 > 2 ? (arraystrong.length - 1) * 40 : 0;
        const spaces: number = arrayspace.length - 1 > 2 ? (arrayspace.length - 1) * 40 : 0;
        const characters = description.replaceAll(/(<([^>]+)>)/ig, '').length;
        return characters + spaces + strongs;
    }

    useEffect(() => {
        validateDescription();
    }, [])

    useEffect(() => {
        const client = ref.current?.clientHeight;
        const scroll = ref.current?.scrollHeight;
        if (showSeeMore == true && client >= scroll) setShowSeeMore(false)
    }, [showSeeMore])

    return (
        <div className="sticky">
            <div className="ProductTop">
                <div className="ProductTop__container">
                    <ProductsBreadcrumb />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div className="ProductTop__category-name">
                            <h1>{title ? title : 'All Products'}</h1>
                            <OrangeLineSmall />
                        </div>
                        <div className="ProductTop__result">
                            {loading == false && productsTotal && productsTotal > 0 && <p><span>{title}  1-{productsPage < productsTotal ? productsPage : productsTotal} </span>  of  {productsTotal}  Results</p>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="ProductTop__headerDescription">
                {description &&
                    <>
                        <div ref={ref} className={`smalldesc ${expandDescription ? "expand" : ""}`} dangerouslySetInnerHTML={{ __html: description }}></div>
                        {showSeeMore &&
                            <a className="seeMore cursor-pointer" onClick={() => setExpandDescription(!expandDescription)}><button>
                                {!expandDescription ? "See More" : "See Less"}</button>
                                <ArrowDownIconDark classStyle={!expandDescription ? "" : "rotate"} /></a>
                        }
                    </>
                }
            </div>
        </div>
    )
}